import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

const Header = () => {
  return (
    <Navbar bg="white" expand="lg" className="shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img src={logo} alt="GUIRETTE SAS" height="50" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" className="text-dark">Accueil</Nav.Link>
            <Nav.Link as={Link} to="/about" className="text-dark">À propos</Nav.Link>
            <Nav.Link as={Link} to="/contact" className="text-dark">Nous contacter</Nav.Link>
            <Button 
              as={Link} 
              to="/demo" 
             style={{ backgroundColor: '#2E8B57', borderColor: '#2E8B57' }} // Vert personnalisé
            className="ms-3 rounded-pill px-4 text-white"
            >
              DEMO
            </Button>

            <Button 
              as={Link} 
              to="/devis-gratuit" 
              variant="dark" 
              className="ms-3 rounded-pill px-4"
            >
              DEVIS GRATUIT
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;